var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import memoizee from 'memoizee';
import RowType from '../components/fields/RowType';
/** Convert a given calendar to a set of form values, to initialize edit/duplicate forms */
var calendarToInitialValues = memoizee(function (dataRepository, calendar) {
    if (calendar === undefined)
        return {};
    return {
        name: calendar.name,
        'start-date': calendar.startDate,
        'end-date': calendar.endDate,
        'service-points': dataRepository.getServicePointsFromIds(calendar.assignments),
        'hours-of-operation': calendar.normalHours.map(function (opening, i) { return (__assign({ type: RowType.Open, i: -1 - i }, opening)); }),
        exceptions: calendar.exceptions.map(function (exception, i) {
            var result = {
                i: -1 - i,
                type: exception.openings.length === 0 ? RowType.Closed : RowType.Open,
                name: exception.name,
                lastRowI: 0,
                rows: []
            };
            if (result.type === RowType.Open) {
                exception.openings.forEach(function (opening, j) {
                    return result.rows.push(__assign({ i: -1 - j }, opening));
                });
            }
            else {
                result.rows.push({
                    i: -1,
                    startDate: exception.startDate,
                    startTime: undefined,
                    endDate: exception.endDate,
                    endTime: undefined
                });
            }
            return result;
        })
    };
});
export default calendarToInitialValues;
